import Vue from 'vue'

import * as TYPES from './types'

export default {
  [TYPES.SET_RESPONSE](state, { questionId, response }) {
    Vue.set(state.userResponses.byId, questionId, response)
  },
  [TYPES.SET_QUESTIONS](state, { allIds, byId }) {
    Vue.set(state.question, 'byId', byId)
    Vue.set(state.question, 'allIds', allIds)
  },
  [TYPES.SET_QUIZZES](state, quizzes) {
    if (quizzes && Array.isArray(quizzes)) {
      Vue.set(state, 'quizzes', quizzes)
    }
  },
  [TYPES.ADD_QUIZ](state, quiz) {
    state.quizzes.push(quiz)
  },
  [TYPES.REMOVE_QUIZ](state, quizId) {
  },
  [TYPES.SET_CURRENT_QUIZ](state, quiz) {
    Vue.set(state, 'currentQuiz', quiz)
  },
  [TYPES.SET_QUIZ_FIREBASE_ID](state, firebaseId) {
    Vue.set(state, 'firebaseId', firebaseId)
  },
  [TYPES.RESET_QUIZ_FIREBASE_ID](state) {
    Vue.delete(state, 'firebaseId')
  },
  [TYPES.SET_RANDOM_QUIZ_QUESTIONS](state, { contentId, questionIds }) {
    Vue.set(state.randomQuizQuestions, contentId, questionIds)
  },
  [TYPES.SET_COMING_FROM_PROGRESSION](state, value) {
    Vue.set(state, 'comingFromProgression', value)
  }
}
